'use strict';

angular.module('admin')
.controller('ProgrammeAdminLangCtrl', function ($scope, model, modelNameField, Language, $http, Programme)
{
    $scope.model = model;
    $scope.modelNameField = modelNameField;

    $scope.selectedBundles = [];

    Language.bindAll({}, $scope, 'languages');

    $scope.createTranslation = function ()
    {
        return $http.post('/api/programmes/duplicate', {
           'id' :  model.parent_id,
           'language_id' :  model.language_id,
        }).then(function (data)
        {
            var m = Programme.inject(data.data);
            return $scope.$close(m);
        });
    };

    $scope.saveModel = function ()
    {
        if (!$scope.model.id) {
            return $scope.createTranslation();
        }

        $scope.model.DSCreate(model, {upsert: true}).then($scope.$close);
    };
});
